import { useRef, useCallback } from 'react';
import { saveAnswer } from '../api/candidate.api';

/**
 * useAutosave – debounced autosave on answer change
 * @param {number} sessionId
 */
const useAutosave = (sessionId) => {
  const timerRef = useRef(null);

  const save = useCallback(
    (questionId, selectedOptionId, isMarkedReview = false, textAnswer = null) => {
      if (!sessionId) return;
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        saveAnswer(sessionId, {
          question_id: questionId,
          selected_option_id: selectedOptionId || null,
          text_answer: textAnswer || null,
          is_marked_review: isMarkedReview,
        }).catch((err) => console.warn('[Autosave] Failed:', err.message));
      }, 600); // 600ms debounce
    },
    [sessionId]
  );

  const flush = useCallback(
    async (questionId, selectedOptionId, isMarkedReview = false, textAnswer = null) => {
      clearTimeout(timerRef.current);
      if (!sessionId) return;
      await saveAnswer(sessionId, {
        question_id: questionId,
        selected_option_id: selectedOptionId || null,
        text_answer: textAnswer || null,
        is_marked_review: isMarkedReview,
      });
    },
    [sessionId]
  );

  return { save, flush };
};

export default useAutosave;
